// extracted by mini-css-extract-plugin
export var indeterminate = "_1i-5";
export var md = "_1i-4";
export var semantic = "_1i-6";
export var sm = "_1i-3";
export var text = "_1i-7";
export var toggleInput = "_1i-0";
export var toggleSwitch = "_1i-1";
export var xs = "_1i-2";